import { CreateAgentDialog } from './create-agent-dialog'

export function AgentsPrimaryButtons() {
  return (
    <div className='flex items-center gap-2'>
      <CreateAgentDialog />
    </div>
  )
}
